export default "__VITE_ASSET__8PPuLCcu__"